export const CancelSubscriptionWarning = () => {
  return (
    <p className={'action-account'}>
      You will have the option to cancel your plan after your first delivery.
      Have a question? Please contact us at{' '}
      <a
        className="action-account-help-link"
        href="mailto:support@cookunity.com">
        support@cookunity.com
      </a>
      .
    </p>
  )
}
